/**
 * メールソフトで開く下書き (宛先・件名・本文)。画面のプレビューと mailto が同じ値を通る。
 * 件名を空にすると、お客様に書いてもらう (プレビューにはその旨を出す)。
 */
export type MailDraft = { to: string; subject: string; body: string };

/** 下書きを mailto URL にする */
export const toMailto = ({ to, subject, body }: MailDraft): string => {
  const params = [
    ...(subject ? [`subject=${encodeURIComponent(subject)}`] : []),
    `body=${encodeURIComponent(body)}`,
  ];
  return `mailto:${to}?${params.join("&")}`;
};
